export default "__VITE_ASSET__CwGKw5ZO__"